const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeCalc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    fill: "none",
    viewBox: "0 0 27 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.3798 .12403)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.6666,
    y: 1.6018,
    width: 9.2403,
    height: 24.496,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 6.0775h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 9.7674h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 13.457h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 17.132 13.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.6666,
    y: 1.6018,
    width: 9.2403,
    height: 24.496,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 6.0775h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 9.7674h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7442 13.457h5.4574",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeCalc);
export default __webpack_public_path__ + "static/media/icon_type_calc.1bf44f8e2e2b54b1c866a709e7162e45.svg";
export { ForwardRef as ReactComponent };